import {
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Fade,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';
import { apiService } from '../../api/axiosClient';
import { Close } from 'mdi-material-ui';
import { forwardRef, useState, useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import Editor from '../../components/editor';


const Transition = forwardRef((props, ref) => <Fade ref={ref} {...props} />)

const DialogFaq = (props) => {
  const { show, setShow, setReload } = props
  const [loading, setLoading] = useState(false)
  const defaultValues = {
    type: '',
    title: ''
  }
  const [content, setContent] = useState('');
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ defaultValues });

  useEffect(() => {
    if(!show) {
      reset(defaultValues);
      setContent('');
    }
  },[show]);

  const onSubmit = async (data, e) => {
    setLoading(true)

    const params = {
      "type": data.type,
      "title": data.title,
      "descript": content
    };

    try {
      await apiService.post('/faqs', params)
      toast.success('업데이트 되었습니다.')
      setReload(reload => reload + 1)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
      setShow(false)
    }
  }

  return (
    <Card>
      <Dialog
        fullWidth
        open={show}
        maxWidth='md'
        scroll='body'
        onClose={() => setShow(false)}
        TransitionComponent={Transition}
        onBackdropClick={() => setShow(false)}
      >
        <form onSubmit={handleSubmit(onSubmit)} id="faqform">
          <DialogContent sx={{ pb: 3, px: { xs: 8, sm: 15 }, pt: { xs: 4, sm: 8 }, position: 'relative' }}>
            <IconButton
              size='small'
              onClick={() => setShow(false)}
              sx={{ position: 'absolute', right: '1rem', top: '1rem' }}
            >
              <Close />
            </IconButton>
            <Box sx={{ mb: 9, textAlign: 'center' }}>
              <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
                FAQ 추가
              </Typography>
            </Box>

            <Grid container spacing={6}>
              <Grid item xs={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <InputLabel id='type'>질문유형</InputLabel>
                  <Controller
                    name='type'
                    control={control}
                    rules={{ required: true }}
                    defaultValue=""
                    renderValue={selected => (selected.length === 0 ? '' : selected)}
                    render={({ field: { value, onChange } }) => (
                      <Select
                        label='질문유형'
                        value={value}
                        onChange={onChange}
                        labelId='type'
                        error={Boolean(errors.type)}
                        variant="standard"
                      >
                        <MenuItem value="취소/환불/교환">취소/환불/교환</MenuItem>
                        <MenuItem value="배송문의">배송문의</MenuItem>
                        <MenuItem value="기타문의">기타문의</MenuItem>
                      </Select>
                    )}
                  />
                  {errors.type && (
                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-type'>
                      필수
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={12} md={6} lg={8}>
                <FormControl fullWidth>
                  <Controller
                    name='title'
                    control={control}
                    rules={{ required: true }}
                    defaultValue=""
                    render={({ field: { value, onChange } }) => (
                      <TextField
                        value={value}
                        label='제목'
                        id='title'
                        onChange={onChange}
                        placeholder='제목을 입력해주세요'
                        error={Boolean(errors.title)}
                        aria-describedby='validation-async-title'
                        variant="standard"
                      />
                    )}
                  />
                  {errors.title && (
                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-title'>
                      필수
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <Controller
                  name='content'
                  control={control}
                  render={({ field: { value } }) => (
                  <Editor 
                    content={value}
                    setContent={setContent} />
                  )}
                />
              </Grid>

            </Grid>
          </DialogContent>
        </form>

        <DialogActions sx={{ pb: { xs: 4, sm: 8 }, justifyContent: 'center' }}>
          <Button type="submit" form="faqform" variant='contained'>
            {loading ? (
              <CircularProgress
                sx={{
                  color: 'common.white',
                  width: '20px !important',
                  height: '20px !important',
                  mr: theme => theme.spacing(2)
                }}
              />
            ) : null}
            등록
          </Button>
          <Button variant='outlined' color='secondary' onClick={() => setShow(false)}>
            취소
          </Button>
        </DialogActions>

      </Dialog>
    </Card>
  )
}

export default DialogFaq
